export default __webpack_public_path__ + "static/media/member.bb7ba66a.svg";